import get from 'lodash/get';

import { IsBoolean, IsInt, IsNotEmpty, Min, ValidateIf } from 'class-validator';

class ChatCampaignSettings {
  id: string;
  version: string;
  createdAt: string;
  updatedAt: string;
  @IsBoolean()
  unlimitedCampaignsPerSession: boolean;

  @IsInt()
  @Min(0)
  @ValidateIf(p => !get(p, 'unlimitedCampaignsPerSession'))
  @IsNotEmpty({ message: 'Input a number' })
  maxCampaignsPerSession: number;
}

export default ChatCampaignSettings;
